import React, { useEffect } from 'react';
import { SmallListItemContainer } from '../../Containers/Containers';
import './Listitem.css';

import SmallAvatar from '../../Avatars/SmallAvatar';
import { useSelector } from 'react-redux';

const SmallListItem = ({ station }) => {
  const { provinceIdMap } = useSelector((state) => state.stations);
  return (
    <SmallListItemContainer>
      <SmallAvatar
        station={station}
        styles={{
          fontSize: '10px',
          padding: '5px',
          width: '25px',
        }}></SmallAvatar>
      <div
        className="box-item small"
        style={{ marginLeft: '5px', paddingBottom: '1px' }}>
        <h6
          style={{
            margin: 0,
            color: 'white',
            fontWeight: 500,
            width: '130px',
            userSelect: 'none',
            opacity: 1,
            fontSize: '0.65rem',
          }}>
          {station.Name}
        </h6>
        <p
          style={{
            margin: 0,
            color: 'white',
            fontWeight: 400,
            fontSize: '8px',
            userSelect: 'none',
            opacity: 1,
          }}>
          {provinceIdMap[station.PlaceId]?.Name ?? 'N/A'}
        </p>
      </div>
    </SmallListItemContainer>
  );
};

export default SmallListItem;
